'use client';

import { CardsSwiper } from '../components/CardsSwiper/CardsSwiper';
import { HeadingSection } from '../components/HeadingSection/HeadingSection';
import { TrustedByCard } from './TrustedByCard/TrustedByCard';
import { trustedByConfig } from './trustedByConfig';

export const TrustedBySection = () => (
  <HeadingSection
    title="Trusted by Leading Web3 Projects"
    description="Drive real growth with tailored, results-driven campaigns"
    headlineComponent="h6"
  >
    <CardsSwiper items={trustedByConfig} renderItem={(item) => <TrustedByCard {...item} />} />
  </HeadingSection>
);
